<template>
    <div>{{ dropdown }}</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
    name: "DropdownEdit",
    data() {
        return {
            dropdownId: parseInt(this.$route.params.dropdownId)
        }
    },
    methods: {
        ...mapActions([
            'getDropdownById'
        ])
    },
    mounted() {
        this.getDropdownById(this.dropdownId)
    },
    computed: {
        ...mapGetters([
            'getStoredDropdown'
        ]),
        dropdown() {
            return this.getStoredDropdown
        }
    }
}
</script>

<style scoped>

</style>
